import { addClass, hasClass, removeClass } from "fire-wind-water/dom";
import * as $ from "jquery";

export function selectToggle() {
  $(document)
    .off("click.form-select-hide")
    .on("click.form-select-hide", function () {
      $(".c-form-select").removeClass("open");
    });

  $(document)
    .off("click.form-select-zz")
    .on(
      "click.form-select-zz",
      ".c-form-select, .c-form-checkbox, .select-main, .form-button",
      (ev) => {
        ev.stopPropagation();
      }
    );

  $(document)
    .off("click.select-mask")
    .on("click.select-mask", ".select-mask", function () {
      $(this).parent().removeClass("open").removeClass("up");
    });
  $(document)
    .off("click.form-select")
    .on("click.form-select", ".select-menu, .select-close", function () {
      $(".c-form-select").removeClass("open").removeClass("up");
      if (hasClass(this.parentNode, "open")) {
        removeClass(this.parentNode, "open");
      } else {
        const h = $(this.parentNode).find(".select-main").innerHeight();
        if (
          document.documentElement.clientHeight -
            this.parentNode.getBoundingClientRect().bottom <
          h
        ) {
          addClass(this.parentNode, "open up");
        } else {
          addClass(this.parentNode, "open");
        }
      }
    });
}
